import { render, staticRenderFns } from "./AdditionalFeatures.vue?vue&type=template&id=36813993&scoped=true"
import script from "./AdditionalFeatures.vue?vue&type=script&lang=js"
export * from "./AdditionalFeatures.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFeatures.vue?vue&type=style&index=0&id=36813993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36813993",
  null
  
)

export default component.exports